import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {DeviceInfoVo} from '../../common/shared/api/nicolas/vo/DeviceInfoVo.interface';

/**
 * 디바이스 정보 조회
 *
 * Origin: pageNicolasApi.getDeviceList
 * API: GET /api/v1/device_list
 */
export async function getDeviceList(
  options?: FetcherOptions
): Promise<ApiResultV2Vo<DeviceInfoVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/device_list',
    {
      method: 'GET',
    },
    options
  );
  return response.data;
}
